import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";

interface MergeConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  label: string;
  sourceItems: any[];
  targetItem: any;
}

export default function MergeConfirmationDialog({
  open,
  onOpenChange,
  onConfirm,
  label,
  sourceItems,
  targetItem,
}: MergeConfirmationDialogProps) {
  const getItemDisplayName = (item: any, label: string) => {
    switch (label) {
      case "Persona":
        return item?.persona || "Unknown Persona";
      case "Outcome":
        return item?.outcome || "Unknown Task";
      case "Scenario":
        return item?.scenario || "Unknown Scenario";
      case "Step":
        return item?.step || "Unknown Step";
      case "Action":
        return item?.action || "Unknown Action";
      default:
        return "Unknown Item";
    }
  };

  const targetDisplayName = getItemDisplayName(targetItem, label);
  const sourceDisplayNames = sourceItems.map(item => getItemDisplayName(item, label));

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Merge {label} Items</AlertDialogTitle>
          <AlertDialogDescription>
            <div className="space-y-2">
              {sourceItems.length === 1 ? (
                <p>
                  Merge "{sourceDisplayNames[0]}" into "{targetDisplayName}"?
                </p>
              ) : (
                <div>
                  <p>Merge {sourceItems.length} items into "{targetDisplayName}":</p>
                  <ul className="list-disc list-inside ml-4 mt-2">
                    {sourceDisplayNames.map((name, index) => (
                      <li key={index} className="text-sm">"{name}"</li>
                    ))}
                  </ul>
                </div>
              )}
              <p className="text-sm text-muted mt-2">
                The content from {sourceItems.length} item{sourceItems.length > 1 ? 's' : ''} will be merged into "{targetDisplayName}".
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            className="bg-primary text-white hover:bg-primary/90"
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
          >
            Merge Items
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}